var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"learn-home d-flex flex-column justify-content-center  align-items-center bd-highlight mb-3",staticStyle:{"margin-top":"150px"}},[_c('job-card',{staticClass:"w-75",attrs:{"job":_vm.job}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }